module.exports = __webpack_public_path__ + "static/media/quafafou.92b3ec6a.jpg";